<template>
	<div class="ops-container">
		<div class="top-bar">
			<div class="navbar-container">
				<TopNavbar ref="top-navbar" :base-path="basePath" :is-offline="this.userStore.currBusiness && this.userStore.currBusiness.block_orders">
					<template #content>
						<div class="row navbar-slot-content">
							<div class="navbar-left-side">
								<h3 v-if="!assistanceCallsQuantity"></h3>
								<div v-else>
									<TopNavbarCoverIcon @click="clickNavCallsNotification" cover-icon="iconBell" :cover-value="assistanceCallsQuantity"/>
								</div>
							</div>
							<div class="navbar-right-side">
								<OpsNavbarSwitcher v-if="(!userStore.requirePin || !!userStore.unlockUserId)" :sections-shown="sectionsShown" />
								<AppButtonIcon v-if="(!userStore.requirePin || !!userStore.unlockUserId) && (extraOptionCards.length > 0 || extraOptionsListItems.length > 0)" prevent-change color="var(--color-bg-primary-1)" icon-name="icon-points" @click-icon="openExtraOptions" />
								<AppButtonIcon v-if="userStore.requirePin && !!userStore.unlockUserId && windowWidth > 350" prevent-change icon-name="icon-lock-white-2" @click-icon="userStore.pinLock()" />
								<!--								<AppButtonIcon v-if="showToggleMobile && (!userStore.requirePin || !!userStore.unlockUserId)" class="toggle-mobile-summary" icon-name="icon-order-summary" @click-icon="ordersStore.showMobileOrderSummary ? ordersStore.deactivateMobileOrderSummary() : ordersStore.activateMobileOrderSummary()" :active="ordersStore.showMobileOrderSummary" />-->
							</div>
						</div>
					</template>
				</TopNavbar>
			</div>
			<AppBottomSheet :forceWidth="bottomSheetWidthSmall" :active="activeExtraOptionsSheet" @toggling-popup="toggleBottomSheet">
				<div class="extra-options-content" v-if="activeExtraOptionsSheet">
					<ModalHeader
						:title="getString('extra_options')"
						:button-text="getString('save')"
						@click-button="saveExtraOptions" />
					<div class="extra-options-cards">
						<div v-for="card in extraOptionCards" :key="card.key" class="extra-option-card" @click="card.callback">
							<img v-if="card.iconSrc" class="extra-option-card-icon" :src="card.iconSrc" :alt="card.key" />
							<div v-else class="extra-option-card-icon" v-html="card.icon"></div>
							<span class="extra-option-card-title">{{ card.title }}</span>
						</div>
					</div>
					<AppList v-if="extraOptionsListItems.length > 0" :items="extraOptionsListItems">
						<template #dropdown-list>
							<AppList :items="sunItems" />
						</template>
					</AppList>
				</div>
			</AppBottomSheet>
			<AppBottomSheet :forceWidth="bottomSheetWidth" :active="customersRegistryActive" @toggling-popup="toggleBottomSheetRegistry">
				<CustomersRegistry v-if="customersRegistryActive" />
			</AppBottomSheet>
			<AppBottomSheet :forceWidth="bottomSheetWidthMid" :active="roomsOrdersStore.manageReservationId !== null" @toggling-popup="toggleBottomSheetReservation">
				<ReservationManage v-if="roomsOrdersStore.manageReservationId !== null" />
			</AppBottomSheet>
			<AppBottomSheet :forceWidth="bottomSheetWidth" :active="roomsOrdersStore.editReservationId !== null" @toggling-popup="toggleBottomSheetReservationEdit">
				<ReservationEdit v-if="roomsOrdersStore.editReservationId !== null" />
			</AppBottomSheet>
			<AppBottomSheet :forceWidth="bottomSheetWidth" :active="roomsOrdersStore.newReservationTableId !== null" @toggling-popup="toggleBottomSheetReservationNew">
				<ReservationNew v-if="roomsOrdersStore.newReservationTableId !== null" />
			</AppBottomSheet>
			<AppBottomSheet :forceWidth="bottomSheetWidth" :active="reportQromoActive" @toggling-popup="toggleBottomSheetQromoReport">
				<QromoReport v-if="reportQromoActive" />
			</AppBottomSheet>
			<AppBottomSheet :forceWidth="bottomSheetWidthSmall" :active="counterStore.qrScannerActive" @toggling-popup="toggleBottomSheetQrScanner">
				<QrScanner v-if="counterStore.qrScannerActive" @customer-scanned="onCustomerScanned" @item-redeemed="onItemRedeemed" @scanner-closed="counterStore.qrScannerActive = false" />
			</AppBottomSheet>
			<Teleport to="#popups">
				<div class="mini-menu-overlay" :class="{hidden: !miniMenu}" @click.self="miniMenu = false">
					<MiniMenu v-if="miniMenu" @saved="miniMenu = false" />
				</div>
			</Teleport>
			<Teleport to="#popups">
				<div class="mini-pos-overlay" :class="{hidden: !miniPos}" @click.self="miniPos = false">
					<MiniPos v-if="miniPos" />
				</div>
			</Teleport>
			<AppPopup
				ref="popup-fiscal-closer"
				:buttons="[{text: getString('cancel'), negative: true}, {text: getString('continue'), callback: printFiscalClosure}]"
				:title="getString('fiscal_closure')+'?'"
				:bodyText="getString('fiscal_closure_confirm')" />
			<AppPopup
				ref="popup-fiscal-closer-missing-receipts"
				:buttons="[{text: getString('cancel'), negative: true}, {text: getString('closure'), negative: true, callback: printFiscalClosure}, {text: getString('yes'), callback: retryFiscalReceipts}]"
				:title="getString(missingFiscal+errorFiscal > 1 ? 'found_missing_receipts' : 'found_missing_receipts_single', [missingFiscal+errorFiscal])"
				:bodyText="getString('retry_missing_receipts_question', [missingFiscal, errorFiscal])" />
			<AppBottomSheet :forceWidth="bottomSheetWidthSmall" :active="retryReceiptsSheetActive" @toggling-popup="toggleBottomSheetRetryReceipts">
				<div v-if="retryReceiptsSheetActive">
					<ModalHeader
						:title="getString('retry_failed_receipts')"
						:button-text="getString('continue')"
						:button-loading="loadingRetryReceipts"
						@click-button="retryFailedReceipts" />
					<p class="retry-receipts-description">{{ getString('retry_failed_receipts_confirm') }}</p>
					<div class="retry-receipts-calendar">
						<DatePicker
							v-model="retryReceiptsDate"
							mode="date"
							color="teal"
							:is-dark="userStore.darkMode"
							:min-date="retryReceiptsMinDate"
							:max-date="new Date()"
							:is-expanded="true"
							borderless />
					</div>
				</div>
			</AppBottomSheet>
			<RedeemedItemPopup ref="redeemed-item-popup" />
		</div>
		<div class="content">
			<div class="main-content">
				<router-view />
				<StationPin v-if="userStore.currBusiness && userStore.requirePin && !userStore.unlockUserId" />
			</div>
		</div>
	</div>
</template>

<script>
import BusinessesSelect from "@/console-new/components/shared/BusinessesSelect.vue";
import TopNavbar from "@/console-new/components/shared/TopNavbar.vue";
import TopNavbarCoverIcon from "@/console-new/components/shared/TopNavbarCoverIcon.vue";
import AppButtonIcon from "@/shared/components/AppButtonIcon.vue";
import AppClickableIcon from "@/shared/components/AppClickableIcon.vue";
import AppSelect from "@/shared/components/AppSelect.vue";
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import AppList from "@/shared/components/AppList.vue";
import MiniMenu from "@/console-new/components/ops/MiniMenu.vue";
import MiniPos from "@/console-new/components/ops/MiniPos.vue";
import OpsNavbarSwitcher from "@/console-new/components/ops/OpsNavbarSwitcher.vue";
import WindowWidth from "@/console-new/mixins/WindowWidth";

import {useLanguageStore, useSvgStore, useNotificationStore} from "@/shared/stores";

import {
	useUserStore,
	useCounterStore,
	useMarketplaceStore,
	useOrdersStore,
	useRoomsStore,
	useRoomsOrdersStore,
	usePrintersStore,
	useMenuStore,
	useAblyStore,
	useEpsonStore,
	useNativeStore, useExperiencesStore
} from "@/console-new/stores";
import AppButton from "@/shared/components/AppButton.vue";
import AppPopup from "@/shared/components/AppPopup.vue";
import {Epson} from "@/console-new/helpers/epson";
import {normalizeOrders, orderFiscalizedStatus} from "@/console-new/helpers/orders";
import CustomersRegistry from "@/console-new/components/ops/CustomersRegistry.vue";
import QromoReport from "@/console-new/components/shared/QromoReport.vue";
import StationPin from "@/console-new/components/shared/StationPin.vue";
import {getNative, isAndroid, isNative} from "@/shared/helpers/webapp";
import {formatDateOnly} from "@/shared/helpers/dates";
import ReservationManage from "@/console-new/components/ops/tables/ReservationManage.vue";
import ReservationEdit from "@/console-new/components/ops/tables/ReservationEdit.vue";
import ReservationNew from "@/console-new/components/ops/tables/ReservationNew.vue";
import QrScanner from "@/console-new/components/ops/QrScanner.vue";
import RedeemedItemPopup from "@/console-new/components/ops/RedeemedItemPopup.vue";
import {DatePicker} from "v-calendar";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const userStore = useUserStore();
		const counterStore = useCounterStore();
		const marketplaceStore = useMarketplaceStore();
		const ordersStore = useOrdersStore();
		const roomsStore = useRoomsStore();
		const roomsOrdersStore = useRoomsOrdersStore();
		const printersStore = usePrintersStore();
		const menuStore = useMenuStore();
		const notificationsStore = useNotificationStore();
		const ablyStore = useAblyStore();
		const svgStore = useSvgStore();
		const epsonStore = useEpsonStore();
		const nativeStore = useNativeStore();
		const experiencesStore = useExperiencesStore();
		return {getString: languageStore.getString, userStore, svgStore, counterStore, marketplaceStore, ordersStore, roomsStore, roomsOrdersStore, printersStore, menuStore, notificationsStore, ablyStore, epsonStore, nativeStore, experiencesStore};
	},
	name: "OpsContainer",
	mixins: [WindowWidth],
	components: {
		ReservationManage,
		ReservationEdit,
		StationPin,
		QromoReport,
		CustomersRegistry,
		ReservationNew,
		OpsNavbarSwitcher,
		QrScanner,
		RedeemedItemPopup,
		DatePicker,
		AppPopup, AppButton, MiniPos, MiniMenu, AppList, ModalHeader, AppBottomSheet, AppSelect, BusinessesSelect, TopNavbar, TopNavbarCoverIcon, AppButtonIcon, AppClickableIcon},
	data() {
		return {
			basePath: "/ops",
			activeExtraOptionsSheet: false,
			newBlockOrders: false,
			miniMenu: false,
			miniPos: false,
			ordersFiscalLastDay: null,
			missingFiscal: 0,
			errorFiscal: 0,
			menuNormalizationAttempts: 0,
			loadingClosure: false,
			customersRegistryActive: false,
			reportQromoActive: false,
			loadingUsers: false,
			loadingRetryReceipts: false,
			retryReceiptsSheetActive: false,
			retryReceiptsDate: new Date(),
		}
	},
	computed: {
		assistanceCallsQuantity() {
			return this.roomsOrdersStore?.roomsTablesCallsNotViewed?.length || 0;
		},
		activeSection() {
			if(this.$route.path === this.basePath + "/counter") {
				return 0;
			} else if(this.$route.path === this.basePath + "/tables") {
				return 1;
			} else {
				return 2;
			}
		},
		showToggleMobile() {
			return this.$route.path !== this.basePath + '/tables';
		},
		sectionsShown() {
			if(this.userStore.currPlans.counter) {
				if(this.userStore.currPlans.order_pay || this.userStore.currPlans.pay_bill) {
					return "all";
				} else {
					return "counter";
				}
			} else {
				return "orders";
			}
		},
		bottomSheetWidth() {
			if(this.windowWidth < 550) {
				return "100%";
			} else if(this.windowWidth < 768) {
				return "550px";
			} else if(this.windowWidth < 1080) {
				return "720px";
			} else if(this.windowWidth < 1440) {
				return "960px";
			} else {
				return "1280px";
			}
		},
		bottomSheetWidthMid() {
			if(this.windowWidth < 550) {
				return "100%";
			} else if(this.windowWidth < 768) {
				return "550px";
			} else if(this.windowWidth < 1080) {
				return "720px";
			} else {
				return "960px";
			}
		},
		bottomSheetWidthSmall() {
			if(this.windowWidth < 550) {
				return "100%";
			} else if(this.windowWidth < 768) {
				return "550px";
			} else {
				return "720px";
			}
		},
		retryReceiptsMinDate() {
			let d = new Date();
			d.setDate(d.getDate() - 12);
			return d;
		},
		topBarTitle() {
			if(this.$route.path === this.basePath + "/orders") {
				return this.userStore.currBusiness && this.userStore.currBusiness.block_orders ? this.getString("disabled") : this.getString("orders");
			} else if(this.$route.path === this.basePath + "/counter") {
				return this.getString("counter_sales");
			} else if(this.$route.path === this.basePath + "/tables") {
				return this.getString("rooms");
			} else {
				return this.getString("ops");
			}
		},
		canGoToKitchen() {
			if(!this.userStore?.user?.user_id || !this.userStore?.businessUsers) { return false; }

			return this.userStore.businessUsers[this.userStore.user.user_id]?.station;
		},
		extraOptionCards() {
			return [
				{
					key: 'daily_report',
					title: this.getString('daily_report'),
					icon: this.svgStore.iconSendReceipt,
					callback: () => { this.reportQromoActive = true; }
				},
				{
					key: 'scan_qr_code',
					title: this.getString('scan_qr_code'),
					icon: this.svgStore.iconQrcode,
					callback: () => { this.counterStore.qrScannerActive = true; }
				},
				{
					key: 'products_availability',
					title: this.getString('products_availability'),
					icon: this.svgStore[this.userStore.currBusiness && this.userStore.currBusiness.type === "other" ? "iconMenuOther" : "iconMenu"],
					callback: () => { this.miniMenu = true; }
				},
				{
					key: 'customers_registry',
					title: this.getString('customers_registry'),
					icon: this.svgStore.iconAnalyticsCustomers,
					callback: () => { this.customersRegistryActive = true; }
				}
			];
		},
		extraOptionsListItems() {
			let items = [];
			if(this.userStore.currPermissions.includes('admin') && this.userStore?.currSubscription !== 'free') {
				items.push({
					title: this.getString('disable_all_orders'),
					switch: true,
					active: this.newBlockOrders,
					callback: (active) => {
						this.newBlockOrders = active;
					}
				});
			}
			if(this.canGoToKitchen) {
				items.push({
					title: this.getString('kitchen_monitor'),
					buttonTitle: this.getString('go_to_x', [this.getString('abbreviated_kitchen_monitor')]),
					callbackButton: () => {
						window.location.replace(URL_HTML + "/console/kitchen");
					}
				});
			}
			if(this.userStore.currBusiness && this.userStore.currBusiness.apiscontrino_id) {
				items.push({
					title: this.getString('retry_failed_receipts'),
					buttonTitle: this.getString('retry'),
					callbackButton: () => {
						this.retryReceiptsDate = new Date();
						this.retryReceiptsSheetActive = true;
					}
				});
			}
			if(isNative()) {
				items.push({
					title: this.getString('qromosun_features'),
					chevronItem: true,
					dropdownSlot: "dropdown-list"
				});
			}
			return items;
		},
		sunItems() {
			let items = [];
			if(this.epsonStore.hasFiscalPrinter && this.userStore.checkOrderDailyClosingAllowed) {
				items.push({
					title: this.getString('fiscal_report'),
					buttonTitle: this.getString('print'),
					callbackButton: () => {
						getNative().dailyReport();
					}
				});
			}
			if(this.epsonStore.hasFiscalPrinter && this.userStore.checkOrderDailyClosingAllowed) {
				items.push({
					title: this.getString('fiscal_closure'),
					buttonTitle: this.getString('print'),
					callbackButton: () => {
						this.loadingClosure = true;
						this.epsonStore.checkFiscalLastDay((r) => {
							this.loadingClosure = false;
							if(r && r.orders.length > 0) {
								this.ordersFiscalLastDay = normalizeOrders(r.orders, r.items, r.items_products, r.addresses, r.rates, r.payments, null);
								this.missingFiscal = this.ordersFiscalLastDay.reduce((acc, curr) => {
									acc += curr.orders.filter(o => (o.station_user_id === null || o.station_user_id === Number(this.userStore.user.user_id)) && orderFiscalizedStatus(o) === "not_fiscalized").length;
									return acc;
								}, 0);
								this.errorFiscal = this.ordersFiscalLastDay.reduce((acc, curr) => {
									acc += curr.orders.filter(o =>(o.station_user_id === null || o.station_user_id === Number(this.userStore.user.user_id)) && orderFiscalizedStatus(o) === "pending").length;
									return acc;
								}, 0);
								if(this.missingFiscal + this.errorFiscal > 0) {
									this.$refs["popup-fiscal-closer-missing-receipts"].toggleStatus(true);
								} else {
									this.$refs["popup-fiscal-closer"].toggleStatus(true);
								}
							} else if(r !== null){
								this.$refs["popup-fiscal-closer"].toggleStatus(true);
							}
						})
					},
					buttonLoading: this.loadingClosure
				});
			}
			items.push({
				title: this.getString('device_settings'),
				buttonTitle: this.getString('settings'),
				callbackButton: () => {
					window.location.href = '/console/sun';
				}
			});
			if(isAndroid() && Android.getManufacturer() === "BBPOS") {
				items.push({
					title: this.getString('configuration'),
					buttonTitle: this.getString('configuration'),
					callbackButton: () => {
						Android.launchStripeSettings();
					}
				});
			}
			return items;
		}
	},
	methods: {
		clickNavCallsNotification() {
			this.roomsOrdersStore.shouldOpenFirstRoomWithNotification = true;
			this.$router.push('/ops/tables');
		},
		printFiscalClosure() {
			if(this.epsonStore.hasFiscalPrinter) {
				getNative().fiscalClosure();
			}
			this.$refs["popup-fiscal-closer"].toggleStatus(false);
			this.$refs["popup-fiscal-closer-missing-receipts"].toggleStatus(false);
		},
		retryFiscalReceipts() {
			this.$refs["popup-fiscal-closer-missing-receipts"].toggleStatus(false);
			if(!this.ordersFiscalLastDay) {
				console.warn("No orders to retry");
				return;
			}

			let orders = this.ordersFiscalLastDay.reduce((acc, curr) => {
				acc.push(...curr.orders);
				return acc;
			}, []);
			this.epsonStore.printFiscalReceipt(orders, true);
			this.ordersFiscalLastDay = null;
			if(isNative()) {
				Epson.queueEmptyCallback = () => {
					if(this.$refs && this.$refs["popup-fiscal-closer"]) {
						this.$refs["popup-fiscal-closer"].toggleStatus(true);
					}
				}
			}
		},
		checkValidRoute() {
			let finalPath = this.basePath + "/orders";
			if(![this.basePath + "/orders", this.basePath + "/counter", this.basePath + "/tables", this.basePath + "/tables/reservations"].includes(this.$route.path)) {
				this.$router.push(finalPath);
			}
		},
		toggleBottomSheet(isOpen) {
			if(!isOpen) {
				this.activeExtraOptionsSheet = false;
			}
		},
		toggleBottomSheetRetryReceipts(isOpen) {
			if(!isOpen) {
				this.retryReceiptsSheetActive = false;
			}
		},
		toggleBottomSheetRegistry(isOpen) {
			if(!isOpen) {
				this.customersRegistryActive = false;
			}
		},
		toggleBottomSheetReservation(isOpen) {
			if(!isOpen) {
				this.roomsOrdersStore.manageReservationId = null;
			}
		},
		toggleBottomSheetReservationEdit(isOpen) {
			if(!isOpen) {
				this.roomsOrdersStore.editReservationId = null;
			}
		},
		toggleBottomSheetReservationNew(isOpen) {
			if(!isOpen) {
				this.roomsOrdersStore.newReservationTableId = null;
			}
		},
		toggleBottomSheetQromoReport(isOpen) {
			if(!isOpen) {
				this.reportQromoActive = false;
			}
		},
		toggleBottomSheetQrScanner(isOpen) {
			if(!isOpen) {
				this.counterStore.qrScannerActive = false;
			}
		},
		onCustomerScanned() {
			this.counterStore.qrScannerActive = false;
			this.activeExtraOptionsSheet = false;
			this.$router.push('/ops/counter');
		},
		onItemRedeemed(itemData) {
			this.counterStore.qrScannerActive = false;
			this.activeExtraOptionsSheet = false;
			this.$router.push('/ops/orders');
			this.$nextTick(() => {
				if(this.$refs?.["redeemed-item-popup"]) {
					this.$refs["redeemed-item-popup"].show(itemData)
				}
			});
		},
		saveExtraOptions() {
			let newBlockOrders = this.newBlockOrders;
			if(newBlockOrders !== this.userStore.currBusiness.block_orders) {
				this.userStore.updateBusiness({block_orders: newBlockOrders}, (success) => {
					if(success) {
						this.activeExtraOptionsSheet = false;
						this.userStore.currBusiness.block_orders = newBlockOrders;
					}
				});
			} else {
				this.activeExtraOptionsSheet = false;
			}
		},
		retryFailedReceipts() {
			if(this.loadingRetryReceipts) { return; }
			this.loadingRetryReceipts = true;
			let startDate = this.retryReceiptsDate ? formatDateOnly(this.retryReceiptsDate) : null;
			this.epsonStore.retryFailedApiscontrinoReceipts(startDate, (success, details, hasMore) => {
				this.loadingRetryReceipts = false;
				this.retryReceiptsSheetActive = false;
				if(success) {
					let notifRef;
					if(details === 0) {
						notifRef = 'retry-failed-receipts-none';
					} else if(hasMore) {
						notifRef = 'retry-failed-receipts-success-more';
					} else if(details === 1) {
						notifRef = 'retry-failed-receipts-success-one';
					} else {
						notifRef = 'retry-failed-receipts-success';
					}
					this.notificationsStore.showNotification(notifRef, [details]);
				} else {
					if(details === 'retry_already_running') {
						this.notificationsStore.showNotification('retry-failed-receipts-running');
					} else if(details === 'auth_denied') {
						this.notificationsStore.showNotification('auth-denied-error');
					} else {
						this.notificationsStore.showNotification('generic-fail');
					}
				}
			});
		},
		openExtraOptions() {
			this.newBlockOrders = this.userStore.currBusiness && this.userStore.currBusiness.block_orders;
			this.activeExtraOptionsSheet = true;
			this.initBusinessUsers();
		},
		initBusinessUsers() {
			if(this.loadingUsers) { return; }
			if(!this.userStore.user || !this.userStore.user.user_id) {
				return;
			}
			if(!this.userStore.businessUsers || Object.keys(this.userStore.businessUsers).length === 0) {
				this.loadingUsers = true;
				this.userStore.getBusinessUsers(()=>{
					this.loadingUsers = false;
				});
			}
		},
		initOrders() {

			if(this.ordersStore.loaded) {
				return;
			}

			let menuLoaded = this.menuStore.loadedBusinessMenu;

			if(menuLoaded && !this.menuStore.loadedAndNormalizedMenu && this.menuNormalizationAttempts < 20) {
				this.menuNormalizationAttempts++;
				setTimeout(this.initOrders, 100);
				return;
			}
			this.menuNormalizationAttempts = 0;

			let roomsLoaded = false;
			if(!menuLoaded) {
				this.menuStore.loadMenu(() => {

					if(roomsLoaded) {
						this.ordersStore.refreshOrders(() => {
							this.ordersStore.loaded = true;
						});
					}

					this.counterStore.getMostSoldProducts();
					menuLoaded = true;

				});
			} else {
				this.counterStore.getMostSoldProducts();
			}
			this.roomsStore.getBusinessRooms(() => {
				if(menuLoaded) {
					this.ordersStore.refreshOrders(() => {
						this.ordersStore.loaded = true;
					});
				}
				roomsLoaded = true;
			});
			if(this.userStore.hasReservations) {
				this.experiencesStore.getBusinessExperiences();
			}
			this.printersStore.getBusinessPrinters();
			this.userStore.getBusinessTerminals(true);
		},
		broadcastActiveSection() {
			if (this.activeSection === 0) {
				this.counterStore.forceBroadcast();
			} else if (this.activeSection === 2) {
				this.ordersStore.forceOrdersBroadcast();
			}
		},
	},
	created() {
		if(typeof Android !== "undefined" && Android.hasSecondScreen && Android.hasSecondScreen()) {
			this.counterStore.initBroadcast();
			this.ordersStore.initOrdersBroadcast();
		}
		if(this.userStore.currBusinessId !== null) {
			this.initOrders();
		}
	},
	mounted() {
		this.broadcastActiveSection();

		if(this.ordersStore.loaded) {
			this.ordersStore.refreshOrders(() => {
				this.ablyStore.startAbly(() => {
					this.ablyStore.subscribeToOpsUpdates(() => {
						this.ordersStore.getFiscalUpdates();
					});
				});
			});
		} else {
			this.ablyStore.startAbly(() => {
				this.ablyStore.subscribeToOpsUpdates(() => {
					this.ordersStore.getFiscalUpdates();
				});
			});
		}

		if(isAndroid()) {
			getNative().updateDevice();
			getNative().isThereExternalPaymentIntent();
		}
	},
	beforeUnmount() {
		this.ablyStore.unsubscribeFromOpsUpdates();
	},
	watch: {
		"$route": {
			handler: function (newRoute) {
				if (!newRoute || !newRoute.path || !newRoute.path.startsWith(this.basePath)) {
					return
				}
				this.checkValidRoute();
			},
			immediate: true
		},
		activeSection() {
			this.broadcastActiveSection();
		},
		'userStore.currBusinessId': function (newVal, oldVal) {
			if (newVal !== null && newVal !== oldVal) {
				this.initOrders();
				this.ablyStore.startAbly(() => {
					if(oldVal) {
						this.ablyStore.unsubscribeFromChannel(ENVIRONMENT+':business-ops:'+oldVal);
					}
					this.ablyStore.subscribeToOpsUpdates(() => {
						this.ordersStore.getFiscalUpdates();
					});
				});
			}
		},
		'ablyStore.isSuspended': function (newVal, oldVal) {
			if(oldVal && !newVal) {
				console.log("Ably resumed, refreshing orders");
				this.ordersStore.refreshOrders();
				this.ordersStore.getFiscalUpdates();
			}
		},
		"epsonStore.fiscalPrinterFailed": {
			handler: function (failed) {
				if(failed) {
					if(failed === "3") {
						this.notificationsStore.showNotification("fiscal-receipt-error-offline");
					} else if(failed === "17") {
						this.notificationsStore.showNotification("fiscal-receipt-error-not-now");
					} else {
						if(typeof failed === "string") {
							this.notificationsStore.showNotification("fiscal-receipt-error-code", [failed]);
						} else {
							this.notificationsStore.showNotification("fiscal-receipt-error");
						}
					}
					this.epsonStore.fiscalPrinterFailed = false;
				}
			},
			immediate: true
		},
		"epsonStore.printReportResult": {
			handler: function (result) {
				if(result !== null) {
					if(result) {
						this.notificationsStore.showNotification("report-printed")
					} else {
						this.notificationsStore.showNotification("generic-fail")
					}
					this.epsonStore.printReportResult = null;
				}
			},
			immediate: true
		},
		"counterStore.externalPaymentIntentData": function(newVal, oldVal) {
			if (newVal && newVal !== oldVal) {
				this.$router.push("/ops/counter");
				this.$nextTick(() => {
					this.counterStore.addCartFakeItem(this.counterStore.externalPaymentIntentData.amount);
					if (this.counterStore.externalPaymentIntentData.details) {
						this.counterStore.orderNotes = this.counterStore.externalPaymentIntentData.details;
					}
					this.counterStore.paymentActive = true;
				})
			}
		},
	},
}
</script>

<style lang="scss" scoped>

.extra-options-cards {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 12px;
	padding: 16px 0;

	.extra-option-card {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 10px;
		padding: 22px 12px;
		border: 1px solid var(--color-primary);
		border-radius: 14px;
		cursor: pointer;
		background: var(--color-bg-primary-1);
		transition: background-color 0.2s ease, box-shadow 0.2s ease;

		&:active {
			background-color: var(--color-bg-primary-2);
			box-shadow: inset 0 0 4px var(--color-box-shadow-3);
		}

		.extra-option-card-icon {
			width: 28px;
			height: 28px;

			:deep(svg) {
				width: 100%;
				height: 100%;

				.fill {
					fill: var(--color-primary);
				}

				.stroke {
					stroke: var(--color-primary);
				}
			}
		}

		.extra-option-card-title {
			font-size: 14px;
			font-weight: 600;
			color: var(--color-primary);
			text-align: center;
			line-height: 1.3;
		}
	}
}

.retry-receipts-description {
	padding: 10px 15px;
	font-size: 14px;
	margin-bottom: 10px;
	color: var(--color-text-secondary);
}

.retry-receipts-calendar {
	display: flex;
	justify-content: center;
}

.mini-menu-overlay, .mini-pos-overlay {
	z-index: 1010;
	display: flex;
	justify-content: flex-end;
	align-items: flex-start;
	position: fixed;
	bottom: 0;
	left: 0;
	width: calc(100vw - (100vw - 100%));
	height: calc(100vh - calc(100vh - 100%));
	background-color: rgba(0, 0, 0, 0.75);
	visibility: visible;
	transition: visibility 0.3s $transition, background-color .3s $transition, opacity .3s $transition;

	&.hidden {
		visibility: hidden;
		background-color: transparent;
		opacity: 0;

	}

}

.ml-auto {
	margin-left: auto;
}

.mini-pos-overlay {
	align-items: center;
	overflow-y: auto;

	@media (max-width: 400px) {
		align-items: center;
	}

	@media (max-height: 700px) {
		align-items: flex-start;
	}
}

.ops-container {
	display: flex;
	flex-direction: column;
	height: 100%;

	.top-bar {
		display: flex;
		flex-direction: row;
		width: 100%;
		box-shadow: 0 1px 3px var(--color-box-shadow-3);

		.navbar-container {
			z-index: 11;
			width: 100%;

			.navbar-slot-content {
				align-items: center;
				justify-content: space-between;
				height: 100%;
				padding: 0 10px;

				@media (max-width: 920px) {
					padding: 0 10px 0 2px;
				}

				.navbar-left-side, .navbar-right-side {
					display: flex;
					align-items: center;
					justify-content: flex-start;
					height: 100%;
				}

				.navbar-right-side {
					flex-grow: 1;
					justify-content: flex-end;
				}


				.select-multi-menu {
					max-width: 150px;
					z-index: 190;

				}

				.settings-navbar-icon {
					margin-left: 4px;
					width: 15px;
					height: 15px;
					padding: 5px;
					box-sizing: content-box;

					:deep(svg) {
						.fill {
							fill: var(--color-svg-primary);
						}
						.stroke {
							stroke: var(--color-svg-primary);
						}
					}
				}

				.navbar-right-side {
					gap: 8px;

					.toggle-mobile-summary {
						display: none;

						@media (max-width: 750px) {
							display: flex;
						}
					}

					.icon-button {
						width: 40px;
						height: 40px;

						&:deep(.btn-inner) {
							width: 33px;
							height: 33px;
						}
					}

					&:deep(.switch) {
						.switch-container {
							height: 40px;

							.switch-slider {
								&:before {
									height: 33px;
								}
								&:after {
									height: 33px;
								}
							}
						}
					}

				}

				@media (max-width: 420px) {
					.select-multi-menu {
						max-width: 120px;
						min-width: 120px;
					}
					.settings-navbar-icon {
						margin-left: 2px;
						width: 14px;
						height: 14px;
						padding: 4px;
					}

					.navbar-right-side {

						.base-button {
							min-width: 80px;
						}

					}

				}

				@media (max-width: 350px) {
					.select-multi-menu {
						max-width: 110px;
						min-width: 110px;
					}

				}

			}

		}
	}

	.content {
		width: 100%;
		height: calc(100% - 60px);

		.main-content {
			width: 100%;
			padding: 0;
			height: 100%;
			position: relative;
		}
	}

	.cover-container {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
		box-shadow: inset 0 0 3px var(--color-box-shadow-3);
		background-color: var(--color-alpha-1);
		border-radius: 7px;
		padding: 9px 8px;
		gap: 5px;
		cursor: pointer;
		animation: slideInFromLeft .3s ease;

		.cover-icon {
			width: 14px;
			height: 14px;
			display: flex;
			justify-content: center;
			align-items: center;
			animation: shakePulse .5s 2 ease-in-out;

			@keyframes shakePulse {
				0% { transform: scale(1) rotate(0deg); }
				20% { transform: scale(1.1) rotate(5deg); }
				40% { transform: scale(1.3) rotate(-15deg); }
				60% { transform: scale(1.1) rotate(5deg); }
				80% { transform: scale(1) rotate(-5deg); }
				100% { transform: scale(1) rotate(0deg); }
			}

			&:deep(svg) {
				width: 100%;
				height: 100%;

				.fill {
					fill: var(--color-svg-primary);
				}

				.stroke {
					stroke: var(--color-svg-primary);
				}
			}
		}

		.cover-value {
			font-size: 14px;
			font-weight: 500;
			color: var(--color-primary);
		}
		
		@keyframes slideInFromLeft {
			0% {
				opacity: 0;
				transform: translateX(-100%) scale(.6);
			}
			100% {
				opacity: 1;
				transform: translateX(0) scale(1);
			}
		}
	}

	@media (max-width: 1200px) {

		.top-bar {

			.right-top-bar {
				width: 220px;
			}

		}
	}

	@media (max-width: 920px) {
		.top-bar {

			.right-top-bar {
				display: none;
			}

		}
	}

}
</style>
